import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import styles from "./Main.module.css";
import {
  ExclamationCircleFilled,
  DeleteOutlined,
  QuestionOutlined,
} from "@ant-design/icons";

import {
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  Modal,
  Radio,
  Table,
  notification,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  createUserApi,
  getAboteOpen,
  getAboutLot,
  getCurrentDateUtil,
  getCurrentDateUtilYYYY,
  getDateUtilYYYY,
  getLot,
  getLotResualts,
  getToken,
  indexMore,
  isAdmin,
  newDateUtil,
  pathRoutes,
  reverseString19,
  reverseString2,
  reverseString3,
  saveBilApi,
  saveLotDateNextApi,
  savelotResualtApi,
  subStringText,
} from "../service/util.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import CardLot from "../card/CardLot";
import Countdown from "react-countdown";
import LoadingCenterSpinSmalljs from "./LoadingCenterSpinSmall";
import LoadingCenterSpinSmall from "./LoadingCenterSpinSmall";
const { confirm } = Modal;

const lotTypes = [
  {
    key: "lot_2",
    name: "2 ตัว",
    text1: "+ เลขเบิ้ล",
    text2: "บน",
    text3: "ล่าง",
  },
  {
    key: "lot_3",
    name: "3 ตัว",
    text1: "+ เลขตอง",
    text2: "บน",
    text3: "โต๊ด",
  },
  { key: "lot_6", name: "6 กลับ" },
  { key: "lot_19", name: "19 ประตู", text1: "บน", text2: "ล่าง" },
  { key: "lot_run", name: "วิ่งเลข", text1: "วิ่งบน", text2: "วิ่งล่าง" },
  { key: "lot_win", name: "เลขวิน" },
];

function LotTableResualt(props) {
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const [lot, setLot] = useState({});
  const [lotId, setLotId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [dataSources, setDataSources] = useState([]);

  const [lotTop, setLotTop] = useState("");
  const [lotBottom, setLotBottom] = useState("");
  const [lotDate, setLotDate] = useState("");
  const [lotDateNext, setLotDateNext] = useState("");
  const [lotDateClose, setLotDateClose] = useState("");
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingSaveNext, setLoadingSaveNext] = useState(false);
  const [isAdminMain, setIsAdminMain] = useState(false);

  useEffect(() => {}, []);

  const columns = [
    {
      title: "ชื่อหวย",
      dataIndex: "lot_name",
      key: "lot_name",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { lot_name }) => (
        <>
          <span style={{ color: "green", fontWeight: lot_name.fontWeight }}>
            {lot_name.text}
          </span>
        </>
      ),
    },
    {
      title: "วันที่",
      dataIndex: "lot_date",
      key: "lot_date",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { lot_date }) => (
        <>
          <span style={{ color: "green", fontWeight: lot_date.fontWeight }}>
            {lot_date.text}
          </span>
        </>
      ),
    },
    {
      title: "3 ตัว",
      dataIndex: "lot_top",
      key: "lot_top",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { lot_top }) => (
        <>
          <span style={{ color: "blue", fontWeight: lot_top.fontWeight }}>
            {lot_top.text}
          </span>
        </>
      ),
    },
    {
      title: "2 ตัว",
      key: "lot_bottom",
      dataIndex: "lot_bottom",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { lot_bottom }) => (
        <>
          <span style={{ color: "green", fontWeight: lot_bottom.fontWeight }}>
            {lot_bottom.text}
          </span>
        </>
      ),
    },
  ];

  const getLotResualt = (fromDate, lot, lotResualts) => {
    for (let a = 0; a < lotResualts.length; a++) {
      console.log("lotResualts[a].lot_date", lotResualts[a].lot_date);
      console.log("fromDate", fromDate);
      if (
        lotResualts[a].lot_id == lot.lot_id &&
        getDateUtilYYYY(fromDate) == getDateUtilYYYY(lotResualts[a].lot_date)
      ) {
        return lotResualts[a];
      }
    }
    return null;
  };

  useEffect(() => {
    let lots = props?.lots;
    let datas = [];
    let selectDateFrom = props?.selectDateFrom;
    let selectDateTo = props?.selectDateTo;
    console.log("selectDateFrom", selectDateFrom);
    console.log("selectDateTo", selectDateTo);

    for (let a = 0; a < lots?.length; a++) {
      let fromDate = newDateUtil(selectDateFrom);
      let toDate = newDateUtil(selectDateTo);
      while (fromDate <= toDate) {
        let lot = lots[a];
        let resualt = getLotResualt(fromDate, lot, props.lotResualts);
        let data = {
          lot_name: {
            text: lot.lot_name,
            fontWeight: "bold",
          },
          lot_date: {
            text: getDateUtilYYYY(fromDate),
            fontWeight: "bold",
          },
          lot_top: { text: resualt?.lot_top, fontWeight: "bold" },
          lot_bottom: { text: resualt?.lot_bottom, fontWeight: "bold" },
        };
        datas.push(data);
        fromDate.setDate(fromDate.getDate() + 1);
      }
    }
    setDataSources(datas);
  }, []);

  return (
    <div style={{ backgroundColor: "white" }}>
      {/* <div className={styles.headerType}>{props.type?.lot_type}</div> */}
      <div className={styles.boxresualtset_table}>
        <div>
          <Table
            className={styles.table}
            columns={columns}
            dataSource={dataSources}
            pagination={false}
            rowClassName={styles.rowClassRotResualt}
          />
        </div>
      </div>
    </div>
  );
}

export default LotTableResualt;
